import { render, staticRenderFns } from "./sleep-period-pie.vue?vue&type=template&id=3b7183c3&scoped=true"
import script from "./sleep-period-pie.vue?vue&type=script&lang=js"
export * from "./sleep-period-pie.vue?vue&type=script&lang=js"
import style0 from "./sleep-period-pie.vue?vue&type=style&index=0&id=3b7183c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7183c3",
  null
  
)

export default component.exports